import firebaseApp from "./config";

const phoneAuth = async(phoneNumber) => {
  const phoneProvider = new firebaseApp.auth.PhoneAuthProvider();
  return await phoneProvider
        .verifyPhoneNumber("+91".concat(phoneNumber), window.recaptchaVerifier)
        .then((id) => {
          console.log("id>>>", id);
          return id;
        })
        .catch((e) => console.log(e));
}

const verifyPhone = async (verificationId, code) => {
  const credential = firebaseApp.auth.PhoneAuthProvider.credential(
    verificationId,
    code
  );
  return await firebaseApp
    .auth()
    .signInWithCredential(credential)
    .then((result) => {
      if (result.user) {
       return result.user;
      }
    })
    .catch((e) => console.log("error>>>>", e));
}

export {phoneAuth, verifyPhone};